<template>
  <tr class="table__header-row">
    <slot></slot>
  </tr> 
</template>

<script>
export default {
    name: 'TableHeaderRow',
    props: {
  },
    components: {
    },
    data() {
        return {
          
        }
    },
}
</script>